import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDBodyText,
  FDCard, FDCardContent, FDIcon,
} from '@facet-wealth/design';
import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import StatList
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/SummaryCardPicker/AccordionSummaryCard/Content/AccordionSummaryCardWithNestedItems/Content/Summary/StatList';
import MetaCollectionFormInline from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';
import Summary from './Content/Summary';
import Action from './Content/Action';

const styles = (theme) => ({
  root: {
    paddingBottom: theme.spacing(2),
  },
  accordion: {
    boxShadow: 'initial',
  },
  accordionDetails: {
    flexDirection: 'column',
    padding: 0,
  },
  metaCollectionForm: {
    padding: 0,
    margin: 0,
    marginBottom: theme.spacing(2),
  },
  metaCollectionRoot: {
    padding: 0,
    margin: 0,
  },
  secondarySummaryItems: {
    paddingLeft: 38, // amount needed to align with start of card
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
});

const OutcomeAccordionSummary = withStyles(() => ({
  root: {},
  content: {
    display: 'flex',
    flexDirection: 'column',
    margin: '0px',
    '&$expanded': {
      margin: '0px 0',
    },
    minWidth: 0,
  },
  expanded: {},
  expandIcon: {
    display: 'flex',
    flexDirection: 'column',
  },
}))(AccordionSummary);

const AccordionSummaryCardWithNestedItems = ({ classes }) => {
  const { resource } = useMetaLayoutContext();
  const optionsRef = React.useRef();

  const hasGoalActions = Boolean(resource?.attr('goalActions')?.resources().list().length > 0);

  return (
    <div className={classes.root}> {/* Can't use DS Box since we only want to apply the padding to the bottom to match the other cards */}
      <FDCard>
        <FDCardContent>
          <Accordion className={classes.accordion} ref={optionsRef}>
            <OutcomeAccordionSummary
              expandIcon={<FDIcon icon="keyboardArrowDown" color="primary" />}
            >
              <Summary resource={resource} />
            </OutcomeAccordionSummary>
            <AccordionDetails className={classes.accordionDetails}>
              <div className={classes.secondarySummaryItems}>
                <StatList summaryItems={resource.attr('secondarySummaryItems')} />
                <FDBodyText value={resource.attr('footnote') ?? ''} size="sm" />
              </div>
              {hasGoalActions && (
                <MetaCollectionFormInline
                  classes={{
                    form: classes.metaCollectionForm,
                    root: classes.metaCollectionRoot,
                  }}
                  collection={resource?.attr('goalActions')}
                  FormProps={{
                    layout: Action,
                    noIndividualSubmitButtons: true,
                  }}
                />
              )}
            </AccordionDetails>
          </Accordion>
        </FDCardContent>
      </FDCard>
    </div>
  );
};

AccordionSummaryCardWithNestedItems.defaultProps = {};

AccordionSummaryCardWithNestedItems.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AccordionSummaryCardWithNestedItems);
